import React, { useState, useEffect } from 'react';

interface WorkCategory {
  GLCodeId: string;
  Code: string;
  Description: string;
  Department?: string;
}

export default function WorkCategoryManager() {
  const [categories, setCategories] = useState<WorkCategory[]>([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ code: '', description: '', department: '' });

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await fetch('/gl-codes');
      const data = await res.json();
      setCategories(data.data || []);
    } catch (err) {
      console.error('Failed to fetch work categories:', err);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await fetch('/gl-codes', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      if (data.success) {
        setFormData({ code: '', description: '', department: '' });
        setShowForm(false);
        fetchCategories();
      } else {
        alert(`Error: ${data.error}`);
      }
    } catch (err: any) {
      alert(`Error: ${err.message}`);
    }
  };

  return (
    <div style={{ marginBottom: '2rem' }}>
      <h2>Work Categories</h2>
      <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '1rem' }}>
        Categories employees can log time against (e.g., Admin, Holiday, Sickness, BAU). These appear alongside projects in timesheet submissions.
      </p>
      <button
        className="btn-primary"
        onClick={() => setShowForm(!showForm)}
        style={{ marginBottom: '1rem' }}
      >
        {showForm ? 'Cancel' : '+ Add Work Category'}
      </button>

      {showForm && (
        <form onSubmit={handleSubmit} style={{ background: '#f9f9f9', padding: '1rem', borderRadius: '4px', marginBottom: '1rem' }}>
          <div className="form-group">
            <label>Category Name</label>
            <input
              type="text"
              value={formData.code}
              onChange={(e) => setFormData({ ...formData, code: e.target.value })}
              placeholder="e.g., Admin, Holiday, Sickness, BAU"
              required
              style={{ width: '100%', padding: '0.5rem', marginBottom: '0.5rem' }}
            />
          </div>
          <div className="form-group">
            <label>Description</label>
            <input
              type="text"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              placeholder="e.g., Administrative work, not project-related"
              required
              style={{ width: '100%', padding: '0.5rem', marginBottom: '0.5rem' }}
            />
          </div>
          <div className="form-group">
            <label>Department (Optional - leave blank for global)</label>
            <input
              type="text"
              value={formData.department}
              onChange={(e) => setFormData({ ...formData, department: e.target.value })}
              placeholder="e.g., Engineering (or leave blank for all departments)"
              style={{ width: '100%', padding: '0.5rem', marginBottom: '0.5rem' }}
            />
          </div>
          <button type="submit" className="btn-primary">Create Work Category</button>
        </form>
      )}

      <div>
        <h3>Work Categories ({categories.length})</h3>
        {categories.length === 0 ? (
          <p style={{ color: '#666' }}>No work categories yet. Create some to get started (Admin, Holiday, Sickness, BAU, etc.)</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ background: '#f5f5f5' }}>
              <tr>
                <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Category Name</th>
                <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Description</th>
                <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Department</th>
              </tr>
            </thead>
            <tbody>
              {categories.map(cat => (
                <tr key={cat.GLCodeId} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '0.75rem' }}><strong>{cat.Code}</strong></td>
                  <td style={{ padding: '0.75rem' }}>{cat.Description}</td>
                  <td style={{ padding: '0.75rem' }}>{cat.Department || '(Global)'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
